import styled from '@emotion/styled';
import {css} from '@emotion/react';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardSemiBoldTypography} from 'patient-ping-remedy/packages/typography';

const Wrapper = styled.div`
  display: flex;
  padding: ${sizes.xSmall};
  margin-top: ${sizes.xSmall};
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

const LeftWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
  margin-right: ${sizes.small};
`;

const ContentRow = styled.div`
  position: relative;
`;

const ContentWrapper = styled.span<{ expanded: boolean }>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ${(props) => !props.expanded && css`
    -webkit-line-clamp: 2;
  `}
  word-break: break-word;
`;

const ViewMoreContainer = styled.span<{ collapsed?: boolean }>`
  ${(props) => props.collapsed && css`
    position: absolute;
    bottom: 0;
    right: 0;
    background: white;
    padding-left: 4px;
  `}
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
  color: inherit;
`;

const ViewMoreButton = styled.button`
  background: none;
  border: none;
  color: ${colors.primary1};
  cursor: pointer;
  padding: 0;
  padding-left: 4px;
  font-size: inherit;
  font-weight: 600;
  white-space: nowrap;


  &:hover {
    text-decoration: underline;
  }
`;

const IconWithBackground = styled.div((props: { backgroundColor?: string }) => css`
  display: flex;
  border-radius: 100%;
  height: 3.6rem;
  width: 3.6rem;
  justify-content: center;
  align-items: center;
  margin-right: ${sizes.xSmall};
  flex-shrink: 0;

  ${props.backgroundColor && css`
    background: ${props.backgroundColor};
  `}
`);

const OverdueText = styled(StandardSemiBoldTypography)`
  color: ${colors.red5};
`;

export { Wrapper, LeftWrapper, IconWithBackground, ContentRow, ContentWrapper,
  ViewMoreContainer, ViewMoreButton, OverdueText};

